import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { TextButton, IconChevronLeft } from 'cdk-radial';
import styled from 'styled-components';
import { setScreen } from '../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../config/uiFactory.config';
import { setAPIDirectoryPage, } from '../../redux/connectedComponent/apiDirectory/apiDirectory.slice';
import { API_DIRECTORY_PAGE } from '../../constants/APIDirectoryConstants';

const StyledIconChevronLeft = styled(IconChevronLeft)`
  fill: #196FE1;
`;

const API_DIR_PATH = '/dp/api-directory';
const MY_APIS_PATH = '/dp/my-apis';
const BACK_BTN_TEXT = 'Go Back';
const BUNDLE_DETAILS_SCREEN = 'Bundle Details';

const BackButton = ({ path = API_DIR_PATH, onBack }) => {
  const history = useHistory();
  const dispatch = useDispatch()
  const { bundleDetails,prevScreen }= useSelector((state)=>state?.apiDirectorySlice)
  const handleClick = () => {
      if(bundleDetails && prevScreen === BUNDLE_DETAILS_SCREEN){
        dispatch(setAPIDirectoryPage({
        page: API_DIRECTORY_PAGE.DETAILS,
        props: { bundleDetails: bundleDetails, bundleDetailsViewEnabled: true },
      }))
      }
    else if (onBack) {
      onBack();
    } else{
      history.push(path);
      if(path === API_DIR_PATH){
        dispatch(setScreen({ screen: screens.API_DIRECTORY }));
      } else if(path === MY_APIS_PATH) {
        dispatch(setScreen({ screen: screens.MY_APIS }));
      }
    }
  };

  return (
    <TextButton
      style={{ marginLeft:'25px',marginTop:'10px', marginBottom:'10px' }}
      onClick={handleClick}
      icon={<StyledIconChevronLeft />}
      text={BACK_BTN_TEXT}
    />
  );
};

export default BackButton;
